<template>
  <el-dialog
    :visible.sync="dialogVisible"
    custom-class="fifl-dialog filter-dialog"
    :show-close="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    :append-to-body="true"
  >
    <template slot="title">
      <h2>대시보드 검색 필터를 설정해주세요.</h2>
    </template>
    <div>
      <h3>수업</h3>
      <el-form label-position="top">
        <el-select
          v-model="filterCourseIndexes"
          multiple
          collapse-tags
          placeholder="수업 선택"
        >
          <el-option
            v-for="(item, index) in courses"
            :key="index"
            :label="item.parent_course"
            :value="index"
          >
            <span class="filter-option">
              <span style="margin-right: 10px;">{{ presentCourseTime(item) }}</span>
              <span>{{ item.parent_course }}</span>
            </span>
          </el-option>
        </el-select>
      </el-form>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <button @click="handleClickCancel">취소</button>
      <button @click="handleClickApplyFilter">필터 적용</button>
    </span>
  </el-dialog>
</template>

<script>
import dateFns from "date-fns";

export default {
	name: "FilterDialog",
	props: ["courses"],
	data() {
		return {
			dialogVisible: false,
			filterCourseIndexes: [],
		};
	},
	computed: {},
	watch: {
		courses() {
			this.filterCourseIndexes = [];
		},
	},
	methods: {
		presentCourseTime(course) {
			let endTime = dateFns.addMinutes(course.start, course.duration);
			return `${dateFns.format(course.start, "HH:mm")} - ${dateFns.format(
				endTime,
				"HH:mm"
			)}`;
		},
		openDialog() {
			this.dialogVisible = true;
		},
		handleClose() {
			this.dialogVisible = false;
		},
		handleClickApplyFilter() {
			this.dialogVisible = false;
			let filterCourses = this.filterCourseIndexes.map(index => {
				return this.courses[index];
			});

			this.$emit("applyFilter", filterCourses);
		},
		handleClickCancel() {
			this.dialogVisible = false;
		},
	},
};
</script>

<style lang="scss">
.filter-dialog {
	width: 370px;
	background: #ffffff;

	.el-dialog__header {
		padding: 30px 50px 15px;
		h2 {
			margin: 0;
			font-size: 18px;
			font-weight: 500;
			font-style: normal;
			font-stretch: normal;
			line-height: normal;
			letter-spacing: -1px;
			color: #4a4a4a;
		}
	}

	.el-dialog__body {
		padding: 0 50px;
		margin-bottom: 60px;

		h3 {
			margin: 0;
			line-height: 24px;
			font-size: 16px;
			font-weight: 500;
			letter-spacing: -0.8px;
			color: #4a4a4a;
		}

		.el-select {
			width: 100%;
		}

		.el-form.el-form--label-top {
			padding: 10px 0;
		}
	}

	@media screen and (max-width: 768px) {
		width: calc(100% - 20px);
		height: 286px;
		top: 10px;

		.el-dialog__body {
			margin-bottom: 0;
		}
	}
}

.filter-option {
	font-size: 14px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1;
	letter-spacing: -0.8px;
	color: #4a4a4a;
}

.v-modal {
	opacity: 0.12;
	background: #202020;
}
</style>
